import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import BrandLogo from '../../../../styles/images/logo/full-vertical.svg';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { handleChangeInputLoginPage } from "../../../../redux/actions/pages/user/login";
import { handleChangeTimerTimePageVerification, handleChangeInputVerificationPage } from "../../../../redux/actions/pages/user/verification";
import { LOGIN } from '../../../../apis'; 
import apiRequest from '../../../../utils/apiRequest';

const Login = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { phoneNumber, inputClass, errorTxt } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);


    const validationPhoneNumber = (event) => {
        const {value: phone} = event.target;
        if(phone.length <= 11)
        	handleChangeInputPhonePageLogin(phone);
    };

    const handleChangeInputPhonePageLogin = (event) => {
        const {name, value} = typeof event === 'string' ? {name: "phoneNumber", value: event} : event.target;
        dispatch(handleChangeInputLoginPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }


	const handleOnInputFocus = (event) => {
        if(errorTxt.length === 0)
        	dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
    };

    const handleOnInputBlur = () => {
        if(errorTxt.length === 0)
        	dispatch(handleChangeInputLoginPage('inputClass', 'Input-InputWrapper-d'));
    };

    const handleBtnFormLogin = (event) => {
        event.preventDefault();

        apiLogin();
    };

    const apiLogin = () => {
    	if(! isBackdropLoading) {
    		if(phoneNumber.length === 0) {
	    		dispatch(handleChangeInputLoginPage('inputClass', 'Input-InputWrapper-error'));
	    		dispatch(handleChangeInputLoginPage('errorTxt', 'لطفا این قسمت را خالی نگذارید!'));
	    	}
	    	else if(phoneNumber.length !== 11) {
	    		dispatch(handleChangeInputLoginPage('inputClass', 'Input-InputWrapper-error'));
	    		dispatch(handleChangeInputLoginPage('errorTxt', 'موبایل باید 11 رقم باشد!'));
	    	}
	    	else {
	    		dispatch(handleChangeInputLoginPage('inputClass', 'Input-InputWrapper-d'));
	    		dispatch(handleChangeInputLoginPage('errorTxt', ''));


	    		apiRequest({
				    dispatch,
				    endpoint: LOGIN,
				    method: 'post',
				    data: { mobile: phoneNumber },
				    token: null,
				    successMessage: null,
				    onSuccess: (res) => {
				      	dispatch(handleChangeTimerTimePageVerification(parseInt(res.timer_time)));
	                    dispatch(handleChangeInputVerificationPage('inputClass', 'Input-InputWrapper-d'));
    					dispatch(handleChangeInputVerificationPage('errorTxt', ''));
    					dispatch(handleChangeInputVerificationPage('code', ''));
	                    navigate(`verify`);
				    },
			  	});
	    	}
    	}
    };


    return (
    	<main className="min-h-full w-full flex items-center flex-col bg-neutral-000 justify-center" style={{height: '100vh'}}>
    		<div className="lg:border-complete-200 rounded-medium p-5 lg:p-8 flex flex-col items-center justify-start lg:justify-center account-wrapper-AccountWrapper-mainBox">
    			<div className="w-full relative flex items-center justify-center mb-3">
    				<div className="flex cursor-pointer right-0 text-neutral-700 transition-all duration-300 ease-out opacity-0 pointer-events-none fixed lg:absolute  logo-Logo-icon">
						<ArrowForwardIcon sx={{fontSize: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={() => navigate(-1)} />
    				</div>
    				<Link to='/'>
						<div className="transform transition-all duration-500 ease-out">
							<img className="inline-block" src={BrandLogo} width={100} alt='دیجیکالا' style={{objectFit: 'contain'}} />
						</div>
					</Link>
    			</div>
    			<div className="w-full">
    				<h1 className="text-h4 text-neutral-900 text-right w-full mt-4">ورود | ثبت‌نام</h1>
		  			<p className="text-body-2 text-neutral-700 mt-4 text-right w-full">سلام!</p>
		  			<p className="text-body-2 text-neutral-700 mb-4 text-right w-full">لطفا شماره موبایل  خود را وارد کنید</p>

		  			<form>
		  				<label className="FormComponentFrame-FormComponentFrame w-full FormComponentFrame-FormComponentFrame-normal">
			  				<div onFocus={handleOnInputFocus} 
	  								onBlur={handleOnInputBlur}  
	  								className={`FormComponentFrame-FormComponentFrame-input-container px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 ${inputClass}`}>
			  					<div className="grow text-body-3">
			  						<input name="phoneNumber" 
			  							type="tel"
								        inputMode="tel"
								        autoComplete="tel"
			  							value={phoneNumber} 
			  							onChange={validationPhoneNumber} 
			  							className={`px-2 TextField-TextField-input text-subtitle w-full TextField-TextField TextField-TextField-secondary-w text-subtitle w-full py-5 lg:py-2 rounded-medium`} />
			  					</div>
			  				</div>
			  				<p className="text-body-2 text-hint-text-error">{errorTxt}</p>
		  				</label>
		  				<button onClick={handleBtnFormLogin} className="relative flex items-center user-select-none styles-btn text-button-1 styles-btn-large styles-btn-primary rounded-medium w-full mt-6 lg:mt-8 text-button-1"  >
		  					<div className="flex items-center justify-center relative grow">
		  						ورود
		  					</div>
	  					</button>
		  			</form>
		  			<p className="text-caption text-neutral-700 mt-4">
		  				ورود شما به معنای پذیرش
		  				<Link className="mx-1 inline-block text-secondary-700">شرایط کوچی </Link>
		  				و 
		  				<Link className="mx-1 inline-block text-secondary-700">قوانین حریم خصوصی </Link>
		  				است
		  			</p>
    			</div>
    		</div>
    	</main>
    );
}

export default Login;